/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Step2_TitleInputs */

const es_cap_step2_title = /** @type {(inputs: Cap_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibe propuestas`)
};

const gl_cap_step2_title = /** @type {(inputs: Cap_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibe propostas`)
};

const en_cap_step2_title = /** @type {(inputs: Cap_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get proposals`)
};

/**
* | output |
* | --- |
* | "Get proposals" |
*
* @param {Cap_Step2_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_step2_title = /** @type {((inputs?: Cap_Step2_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Step2_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_step2_title(inputs)
	if (locale === "en") return en_cap_step2_title(inputs)
	return es_cap_step2_title(inputs)
});